import React, { useState } from "react";
import { Select,MantineProvider  } from '@mantine/core';
import Alert from "./Alert";
import '@mantine/core/styles.css';

function Counter(props) {
    const [alert, setAlert] = useState(null);

    const showAlert = (message, type) => {
        setAlert({
            msg: message,
            type: type,
        });
        setTimeout(() => {
            setAlert(null);
        }, 1500);
    };
    const [count, setCounter] = useState(0);
    // const [num,setNum] =useState()
    function subtract() {
        if (count <= 0) {
            showAlert("minimun number reached", "warning");
        } else {
            if (count == "") {
                setCounter(0);
            } else {
                let c = parseInt(count);

                setCounter((c -= 1));
            }
        }
    }
    function addition() {
        if (count >= 100) {
            showAlert("maximum number reached", "warning");
        } else {
            if (count == "") {
                setCounter(1);
            } else {
                let c = parseInt(count);
                setCounter((c += 1));
            }
        }
    }
    function setNumber(event) {
        if (event.target.value < 0 || event.target.value > 100) {
            showAlert("please enter a number between 0 to 100", "warning");
        } else {
            setCounter(event.target.value);
            // setNum("")
        }
    }
    return (
        <MantineProvider >
            <Alert alert={alert} />
            <div
                className="counter"
                style={{ display: "flex", gap: "20px", margin: "30px" }}
            >
                <button onClick={subtract} disabled={count <= 0}>
                    Subtract
                </button>
                <h1>
                    <input
                        type="number"
                        value={count}
                        onChange={setNumber}
                        onKeyDown={(evt) =>
                            ["e", "E", "+", "-"].includes(evt.key) &&
                            evt.preventDefault()
                        }
                    />
                </h1>
                <button onClick={addition} disabled={count >= 100}>
                    Addition
                </button>
            </div>

            <Select
                label="Your favorite library"
                placeholder="Pick value"
                data={['React', 'Angular', 'Vue', 'Svelte']}
                defaultValue='hello'
                clearable
            />

        </MantineProvider>
    );
}

export default Counter;
